import React from 'react';
import type { StepProps } from '~/lib/types/netlify';

interface DeploymentStepsProps {
  currentStep: number;
}

export const DeploymentSteps = ({ currentStep }: DeploymentStepsProps) => {
  return (
    <div className="space-y-6">
      <Step step={2} currentStep={currentStep} label="Create Site" />
      <Step step={3} currentStep={currentStep} label="Build" />
      <Step step={4} currentStep={currentStep} label="Deploy" />
    </div>
  );
};

const Step = ({ step, currentStep, label }: StepProps) => {
  const isComplete = currentStep > step || (step === 4 && currentStep === 4);
  const isCurrent = currentStep === step && step !== 4;

  return (
    <div className="flex items-center">
      <div className="relative flex flex-col items-center">
        {/* Vertical line above (except for first step) */}
        {step > 2 && (
          <div
            className={`absolute top-0 left-1/2 w-0.5 h-3 -translate-y-full -translate-x-1/2 
              ${isComplete || currentStep >= step - 1 ? 'bg-[#22c55e]' : 'bg-white/20'}`}
          />
        )}

        {/* The step circle */}
        <div
          className={`w-5 h-5 rounded-full flex items-center justify-center z-10
            ${isComplete ? 'bg-[#22c55e]/10 border border-[#22c55e]' : ''}
            ${isCurrent ? 'border-2 border-alpha-primary-start bg-alpha-primary-start/10' : ''}
            ${!isComplete && !isCurrent ? 'border border-white/20 bg-white/5' : ''}`}
        >
          {isComplete ? (
            <div className="i-ph:check w-3 h-3 text-[#22c55e]" />
          ) : isCurrent ? (
            <div className="i-ph:circle-notch w-3 h-3 animate-spin text-alpha-primary-start" />
          ) : null}
        </div>

        {/* Vertical line below (except for last step) */}
        {step < 4 && (
          <div
            className={`absolute bottom-0 left-1/2 w-0.5 h-3 translate-y-full -translate-x-1/2
              ${isComplete ? 'bg-[#22c55e]' : 'bg-white/20'}`}
          />
        )}
      </div>

      <div className="ml-4">
        <p
          className={`text-sm font-medium 
            ${isComplete ? 'text-[#22c55e]' : ''} 
            ${isCurrent ? 'text-white' : ''} 
            ${!isComplete && !isCurrent ? 'text-white/40' : ''}`}
        >
          {label}
        </p>
      </div>
    </div>
  );
};
